export var CleaningFrequency;
(function (CleaningFrequency) {
    CleaningFrequency["DAILY"] = "daily";
    CleaningFrequency["WEEKLY"] = "weekly";
    CleaningFrequency["MONTHLY"] = "monthly";
})(CleaningFrequency || (CleaningFrequency = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "monday";
    DayOfWeek["TUESDAY"] = "tuesday";
    DayOfWeek["WEDNESDAY"] = "wednesday";
    DayOfWeek["THURSDAY"] = "thursday";
    DayOfWeek["FRIDAY"] = "friday";
    DayOfWeek["SATURDAY"] = "saturday";
    DayOfWeek["SUNDAY"] = "sunday";
})(DayOfWeek || (DayOfWeek = {}));
export const SUBSCRIPTION_TIERS = {
    TEN_WEEKLY_NOTES: 'TEN_WEEKLY_NOTES',
    TWENTY_WEEKLY_NOTES: 'TWENTY_WEEKLY_NOTES',
    THIRTY_WEEKLY_NOTES: 'THIRTY_WEEKLY_NOTES',
    FORTY_WEEKLY_NOTES: 'FORTY_WEEKLY_NOTES',
    FIFTY_WEEKLY_NOTES: 'FIFTY_WEEKLY_NOTES',
};
/**
 * Default organization data
 */
export const defaultOrganization = {
    name: '',
    knowledgeBaseId: '',
    algoliaSearchApiKey: '',
    recipesCategories: [],
    restaurants: [],
    pendingEnergyTrigger: null,
    energyOfferCooldownUntil: null,
    energyTariffReviewRequestedAt: null,
    lastSalesTrackPopupShownAt: null,
    profitabilityCelebrationsCount: 0,
    pendingReferralTrigger: null,
    pendingReferralContext: null,
    referralOfferCooldownUntil: null,
    referralR1Enqueued: false,
    referralLastR2PeriodId: null,
    pendingAdvisoryTrigger: null,
    pendingAdvisoryContext: null,
    advisoryOfferCooldownUntil: null,
    tipiAdvisoryHiredAt: null,
    documentQuotaTotal: 0,
};
//# sourceMappingURL=OrganizationEntity.js.map